import s from "./t7.module.scss";

import { loaderPostFetch, csAmount } from "../../util";
//import { itloader } from "../../index";
import React, { useState, useEffect } from "react";
import { Outlet, Link, useLoaderData, Form } from "react-router-dom";

import Notif from "../../../../components/notif";

const production = true;

function Ico1({ src, onClick, label }) {
 return (
  <div className={s?.ico1} onClick={onClick}>
   <img src={`${production ? "/wp-user" : ""}/d7/${src}.svg`} />
   <div className={s.txtico1}>{label || ""}</div>
  </div>
 );
}
function h(n) {
 let y = n.replace("_", " ");
 return y;
}
function Ico2({ src, label, amt, type }) {
 return (
  <div className={s?.ico2}>
   <div className={s?.lo}>
    <img src={`${production ? "/wp-user" : ""}/d7/${src}.svg`} />
   </div>

   <div className={s?.c2con}>
    <div className={s?.c2}>
     <div className={s?.label}>{label}</div>
     <div className={`${s?.amt} ${type == "credit" ? s?.credit : s?.debit}`}>
      {amt}
     </div>
    </div>
   </div>
  </div>
 );
}
function Ico3({ src }) {
 return (
  <div className={s?.ico3}>
   <img src={`${production ? "/wp-user" : ""}/d7/${src}.svg`} />
  </div>
 );
}

function Dee() {
 return (
  <>
   <Outlet />
  </>
 );
}
export default function DashboardPage7() {
 const [n, sN] = useState({ display: false, type: "success", msg: "" });

 const { data, u, transactions, currency, tb, haspin } = useLoaderData();

 const na = () => {
  sN({ display: true, type: "error", msg: "Not Available in your region" });

  setTimeout(() => {
   sN({ display: false, type: "success", msg: `` });
  }, 5000);
 };
 const [disAmount, sDisAmount] = useState();
 useEffect(() => {
  let y = window.localStorage.getItem("displayAmount");
  sDisAmount(y);
 }, []);
 useEffect(() => {
  if (disAmount) {
   window.localStorage.setItem("displayAmount", disAmount);
  }
 }, [disAmount]);

 useEffect(() => {
  if (typeof haspin != "undefined") {
   if (!haspin) {
    window.location.href = "dashboard/pincreation";
   }
  }
 }, [haspin]);
 return (
  <>
   <Notif display={n?.display} type={n?.type} msg={n?.msg} />

   <div className={s.b}>
    <div
     className={s.b1}
     style={{
      backgroundImage: `url(${production ? "/wp-user" : ""}/d7/m.svg)`,
     }}
    ></div>
    <div
     className={s.b2}
     style={{
      backgroundImage: `url(${production ? "/wp-user" : ""}/d7/s1.svg)`,
     }}
    ></div>
    <div
     className={s.b3}
     style={{
      backgroundImage: `url(${production ? "/wp-user" : ""}/d7/s2.svg)`,
     }}
    >
     {/*smaller one*/}
    </div>

    <div className={s.tb}>
     <div className={s.ab}> Available Balance </div>
     <div className={s.amt}>
      {" "}
      <>{`${currency}${
       tb?.current_balance ? csAmount(tb?.current_balance) : "0.00"
      }`}</>
     </div>

     <div className={s.hmm}>
      <div className={s.hco}>
       <div className={s.titl}>Account Number</div>
       <div className={s.copyrow}>
        <div className={s.copyan}>{data?.account_no}</div>
        <div
         className={s.copy}
         onClick={() => {
          navigator.clipboard.writeText(data?.account_no).then(
           () => {
            console.log("s");
            /* clipboard successfully set */
            sN({
             ...n,
             display: true,
             type: "success",
             msg: "Copied to clipboard",
            });
            setTimeout(() => {
             sN({
              ...n,
              display: false,
              type: "success",
              msg: "Copied to clipboard",
             });
            }, 5000);
           },
           () => {
            console.log("f");
            /* clipboard write failed */
           }
          );
         }}
        >
         <img src={`${production ? "/wp-user" : ""}/d7/copy.svg`} />
        </div>
       </div>
      </div>
      <div className={s.hco}>
       <div className={s.titl}>Account Status</div>
       <div className={s.tier}>{u?.current_plan || "Tier 1"}</div>
      </div>
     </div>

     <div className={s.four}>
      <Ico1
       src="sent"
       label="send"
       onClick={() => {
        window.location.href = `dashboard/send`;
       }}
      />
      <Ico1
       src="receive"
       label="receive"
       onClick={() => {
        window.location.href = `dashboard/add-funds/it`;
       }}
      />
      <Ico1 src="loan" label="loan" onClick={na} />
      <Ico1
       src="topup"
       label="Topup"
       onClick={() => {
        window.location.href = `dashboard/add-funds`;
       }}
      />
     </div>
    </div>
   </div>

   <div className={s?.creditdebit}>
    <Ico2
     src="tcredit"
     label="Total Credit"
     amt={u?.total_credit}
     type="credit"
    />
    <Ico2 src="tdebit" label="Total Debit" amt={u?.total_debit} type="debit" />
   </div>

   <div className={s?.recentitems}>
    <div className={s.rt}>
     <div className={s.rttxt}>Recent Transactions</div>
     <img src={`${production ? "/wp-user" : ""}/d7/more.svg`} />
    </div>

    {!transactions || transactions?.length == 0 ? (
     <div className={s.empty}>
      <div className={s.c}>
       <div className={s.h}>No Transaction History</div>
       <div className={s.s}>
        Your recent transaction should appear here contact
        <br /> support for any issues
       </div>
      </div>
     </div>
    ) : (
     <>
      {transactions ? (
       <div className={s.trx}>
        {transactions?.map((n, i) => {
         return (
          <Link to={`dashboard/receipt/${n?.ref2}`} key={i} className={s.lselc}>
           {/*
          <div key={i} className={s.lselc}>*/}
           <div className={s.lsel}>
            <Ico3 src={n?.transaction_type == "credit" ? "down" : "up"} />
            <div className={s.el1}>
             <div className={s.titlel}>
              {" "}
              <b>{n?.name}</b>
             </div>
             <div className={s.datev}> {new Date(n?.date).toDateString()}</div>
            </div>
           </div>

           <div className={s.rig}>
            <div
             className={`${s.amount} ${n?.transaction_type == "credit" ? s.credit : s.other}`}
            >
             {n?.transaction_type == "credit" ? `+${currency}` : `-${currency}`}
             {n?.amount ? csAmount(n?.amount) : "0.00"}
            </div>

            <div className={s[n?.status]}>{h(n?.status)}</div>
           </div>
           {/*
          </div>*/}
          </Link>
         );
         //return <Entry data={n} key={i} currency={currency} />;
        })}
       </div>
      ) : null}
     </>
    )}
   </div>
  </>
 );
}

/*
export const droutes7 = {
 path: `dashboard7`,
 element: <Dee />,
 children: [{ index: true, element: <DashboardPage7 />, loader: itloader }],
};*/
